import { Link } from 'react-router-dom'
import { ArrowForwardIcon } from '~/@mid_ui/icons/ArrowForwardIcon'
import { CrossIcon } from '~/@mid_ui/icons/CrossIcon'
import { HeadingThree } from '~/@mid_ui/typography/HeadingThree'
import { Text } from '~/@mid_ui/typography/Text'
import { useIdentityVerificationStatus } from '../useIdentityVerificationStatus'
import { useUser } from '~/@biz_account/useUser/useUser'
import { Button } from '~/shadcn/ui/button/button'

function IdentityVerificationDeclined() {
  const { reloadUser } = useUser()
  const { setIdentityReverifyStatus } = useIdentityVerificationStatus()
  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col justify-between gap-4 p-10 bg-[#FFC7D0]">
        <div className="flex flex-row justify-between gap-10">
          <HeadingThree className="font-bold leading-8 text-3xl md:text-3xl">
            Overenie sa nepodarilo. Skúste to prosím znovu.
          </HeadingThree>
          <CrossIcon className="shrink-0" />
        </div>
        <Text className="font-semibold">
          Ak máte problém s overením, kontaktujte prosím našu{' '}
          <Link to="mailto:info@investinslovakia.eu" className="text-accent">
            podporu
          </Link>
          .
        </Text>
      </div>
      <Button
        variant="accent"
        className="md:w-fit"
        onClick={async () => {
          await setIdentityReverifyStatus()
          await reloadUser()
        }}>
        <span>Overiť identitu znova</span>
        <ArrowForwardIcon className="ml-2" />
      </Button>
    </div>
  )
}

export { IdentityVerificationDeclined }
